import { Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const VideoComponent = ({ url }) => {
  // Normalize input: if it's a string, convert to array
  const videoList = Array.isArray(url) ? url : [url];
  const [selectedVideo, setSelectedVideo] = useState(videoList[0]);

  return (
    <Box
      sx={{
        width: '100%',
        p: 3,
        pt:4,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {/* Main Video Player */}
      <Box
        sx={{
          width: '100%',
          height: 555,
          // borderRadius: 2,
          overflow: 'hidden',
          // boxShadow: 3,
        }}
      >
        <iframe
          src={selectedVideo}
          width="100%"
          height="100%"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="Main Video"
          style={{
            border: 'none',
            width: '100%',
            height: '100%',
          }}
        />
      </Box>

      {/* Video Thumbnails (if more than one) */}
      {videoList.length > 1 && (
        <Grid container spacing={2} justifyContent="center">
          {videoList.map((videoUrl, index) => (
            <Grid item key={index}>
              <Box
                sx={{
                  width: 180,
                  height: 120,
                  borderRadius: 1,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  border: selectedVideo === videoUrl ? '3px solid #F5AE1B' : '2px solid #ccc',
                  transition: 'border-color 0.3s',
                  '&:hover': {
                    borderColor: '#F5AE1B',
                  },
                }}
                onClick={() => setSelectedVideo(videoUrl)}
              >
                <iframe
                  src={videoUrl}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  title={`Video ${index + 1}`}
                  style={{
                    pointerEvents: 'none',
                    width: '100%',
                    height: '100%',
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

VideoComponent.propTypes = {
  url: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
};

export default VideoComponent;
